// Verde vocabulary expansion — aggregator.
//
// Collects every per-theme `VOCAB_<THEME>` module (net-new, collision-free cards
// that extend the base blocks in ./vocabulary.js) into a single flat array of
// { theme, tier, rows } blocks. ./vocabulary.js folds these into buildVocabulary()
// so the new cards flow through VOCABULARY_CARDS — the single source for both the
// browse view and the PocketBase seed (which upserts on the unique `spanish` key).
//
// Block shape is identical to the THEMES array in ./vocabulary.js:
//   { theme, tier, rows: [ [spanish, english, emoji, pos, gender, exEs, exEn], ... ] }

import { VOCAB_IDENTITY } from "./vocab-identity.js";
import { VOCAB_FAMILY } from "./vocab-family.js";
import { VOCAB_HOUSE } from "./vocab-house.js";
import { VOCAB_FOOD } from "./vocab-food.js";
import { VOCAB_BODY_HEALTH } from "./vocab-body-health.js";
import { VOCAB_DAILY_ROUTINE } from "./vocab-daily-routine.js";
import { VOCAB_WORK_STUDY } from "./vocab-work-study.js";
import { VOCAB_TRAVEL } from "./vocab-travel.js";
import { VOCAB_TIME_WEATHER } from "./vocab-time-weather.js";
import { VOCAB_SHOPPING } from "./vocab-shopping.js";
import { VOCAB_TOWN } from "./vocab-town.js";
import { VOCAB_LEISURE } from "./vocab-leisure.js";
import { VOCAB_FEELINGS } from "./vocab-feelings.js";
import { VOCAB_NATURE } from "./vocab-nature.js";
import { VOCAB_DESCRIBING } from "./vocab-describing.js";
import { VOCAB_SCIENCE_TECH } from "./vocab-science-tech.js";
import { VOCAB_POLITICS } from "./vocab-politics.js";
import { VOCAB_MEDIA } from "./vocab-media.js";

// Order mirrors the 18 canonical themes / the VOCAB_THEMES registry.
export const EXTRA_THEME_BLOCKS = [
  ...VOCAB_IDENTITY,
  ...VOCAB_FAMILY,
  ...VOCAB_HOUSE,
  ...VOCAB_FOOD,
  ...VOCAB_BODY_HEALTH,
  ...VOCAB_DAILY_ROUTINE,
  ...VOCAB_WORK_STUDY,
  ...VOCAB_TRAVEL,
  ...VOCAB_TIME_WEATHER,
  ...VOCAB_SHOPPING,
  ...VOCAB_TOWN,
  ...VOCAB_LEISURE,
  ...VOCAB_FEELINGS,
  ...VOCAB_NATURE,
  ...VOCAB_DESCRIBING,
  ...VOCAB_SCIENCE_TECH,
  ...VOCAB_POLITICS,
  ...VOCAB_MEDIA,
];
